 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		11: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"1bfc9850","3":"5ab506d59f58e63f4f8f21c447a82d09278471ef","4":"f73a5f0018b8e37c139e31a28f668c4568b9e4ec","5":"0e15609becceb526a9a7c8cb4f48d715ce02325a","6":"f8a15fcee5f7c08f7b8e59f95abee387f5253c56","7":"8bbe987d31cef249a80ecb44d946a86ea80f50d2","8":"29107295","9":"6d7b5f46d489312af8c6547e273003602eb316ef","10":"b637e9a5","12":"9a1974b2","14":"component---src-pages-404-js","15":"component---src-pages-categories-index-js","16":"component---src-pages-contact-thanks-js","17":"component---src-pages-tags-index-js","18":"component---src-templates-about-me-page-js","19":"component---src-templates-about-us-page-js","20":"component---src-templates-application-security-services-js","21":"component---src-templates-application-security-testing-js","22":"component---src-templates-archives-js","23":"component---src-templates-blog-page-js","24":"component---src-templates-blog-post-js","25":"component---src-templates-categories-js","26":"component---src-templates-contact-page-js","27":"component---src-templates-content-page-js","28":"component---src-templates-data-protection-js","29":"component---src-templates-dynamic-penetration-testing-js","30":"component---src-templates-easy-lp-js","31":"component---src-templates-embedded-security-js","32":"component---src-templates-hybrid-security-analysis-js","33":"component---src-templates-implications-consequences-data-js","34":"component---src-templates-index-page-js","35":"component---src-templates-landing-page-js","36":"component---src-templates-mobile-application-js","37":"component---src-templates-network-penetration-testing-js","38":"component---src-templates-network-security-testing-js","39":"component---src-templates-network-vulnerability-scanning-js","40":"component---src-templates-ppc-main-lp-page-js","41":"component---src-templates-ppc-main-lp-thanks-page-js","42":"component---src-templates-resources-page-js","43":"component---src-templates-resources-post-js","44":"component---src-templates-resources-post-thanks-js","45":"component---src-templates-security-assessments-js","46":"component---src-templates-sitemap-js","47":"component---src-templates-ssdlc-development-phase-js","48":"component---src-templates-ssdlc-introduction-js","49":"component---src-templates-ssdlc-page-js","50":"component---src-templates-ssdlc-planning-design-phase-js","51":"component---src-templates-ssdlc-release-phase-js","52":"component---src-templates-ssdlc-requirements-phase-js","53":"component---src-templates-ssdlc-security-training-phase-js","54":"component---src-templates-ssdlc-verification-testing-phase-js","55":"component---src-templates-static-analysis-js","56":"component---src-templates-terms-and-conditions-for-giveaway-js","57":"component---src-templates-thanks-page-js","58":"component---src-templates-video-page-js","59":"component---src-templates-web-application-js","60":"component---src-templates-web-dynamic-penetration-testing-js","61":"component---src-templates-web-hybrid-analysis-js","62":"component---src-templates-web-static-analysis-js","63":"component---src-templates-why-security-testing-js"}[chunkId]||chunkId) + "-" + {"0":"b935065d6cf7164de9f5","1":"e9d24b1846c7d6eb9685","2":"2226b67eafdfbbde4989","3":"789f2ef04cf2b9dece76","4":"631e6ac63e89d8be9468","5":"3c83819588fbced4d571","6":"d1823cc33ec8467123f4","7":"88fe4e80848303ceac1b","8":"682b9ae762e6af00b916","9":"c120559d8801c6b83731","10":"caf4b3c08554fbcf3972","12":"6ecb047d03fc84262272","14":"65633f9be88d23dfcf50","15":"6ced9565bc7d0bfdd4ee","16":"2ce31494d9a387087982","17":"a9b99df0828593f6e939","18":"44304e8f3c827f09ac8e","19":"7521c2130eec4c9118d7","20":"a0c7fc06184583f854b4","21":"f682448e90940d6acb7f","22":"e002f44101e5548c9fbf","23":"75e444b0b18db68d8676","24":"a0e8d572ac2f0c03e055","25":"5c1693247ec4a91afa70","26":"db1e7927c286b1653c83","27":"a9e218fe0deb3323c96f","28":"4407b2973b2957ff272e","29":"1bf4d6dd4c8d1b4b3473","30":"c57b5f0e05ebeda0ec82","31":"5fa227124f2e9dc459f3","32":"3d72539d51d558bacbb7","33":"b1453f2d43cfde8aef10","34":"5a1e84842619ccae1cdd","35":"02d6f64e2cb4fc1200c7","36":"63693db772836622177f","37":"4e7ed8d02c68a3c6a45c","38":"f710906fe06935b220b4","39":"2d0c70961064d7888ea6","40":"1914c9bddc8e019b7c4f","41":"8c147519676854b3ae5b","42":"7bf57edf9ce034fe7e6e","43":"916abdb86b13ca107ada","44":"087daa7c08ee967a7ba0","45":"3318d7a5f5c47e5b06dd","46":"e3386b91f8db64815ffa","47":"599b1a47ccd2566f7a2d","48":"25e7cc4f9a9e4c344500","49":"8e0075d3c763d6acf698","50":"784a4685635bce70a35b","51":"5000bc2aaf2d7e21b637","52":"8a5ccc56550ca85e2cc7","53":"2b846726835f8589dc9a","54":"9421589c22041bc8b903","55":"8d1d3c075878fa9f8516","56":"9ce6a2442d0c23144571","57":"a0176ab48ba563b60ff4","58":"d89df82c482c5d6919ac","59":"50b646718010e5b898b2","60":"0f4d75c4a3c0dbb430ef","61":"0096676bc11b01b1d602","62":"7411b52057f994ffbad5","63":"97c21e8f71c22ae4e60f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"1bfc9850","3":"5ab506d59f58e63f4f8f21c447a82d09278471ef","4":"f73a5f0018b8e37c139e31a28f668c4568b9e4ec","5":"0e15609becceb526a9a7c8cb4f48d715ce02325a","6":"f8a15fcee5f7c08f7b8e59f95abee387f5253c56","7":"8bbe987d31cef249a80ecb44d946a86ea80f50d2","8":"29107295","9":"6d7b5f46d489312af8c6547e273003602eb316ef","10":"b637e9a5","12":"9a1974b2","14":"component---src-pages-404-js","15":"component---src-pages-categories-index-js","16":"component---src-pages-contact-thanks-js","17":"component---src-pages-tags-index-js","18":"component---src-templates-about-me-page-js","19":"component---src-templates-about-us-page-js","20":"component---src-templates-application-security-services-js","21":"component---src-templates-application-security-testing-js","22":"component---src-templates-archives-js","23":"component---src-templates-blog-page-js","24":"component---src-templates-blog-post-js","25":"component---src-templates-categories-js","26":"component---src-templates-contact-page-js","27":"component---src-templates-content-page-js","28":"component---src-templates-data-protection-js","29":"component---src-templates-dynamic-penetration-testing-js","30":"component---src-templates-easy-lp-js","31":"component---src-templates-embedded-security-js","32":"component---src-templates-hybrid-security-analysis-js","33":"component---src-templates-implications-consequences-data-js","34":"component---src-templates-index-page-js","35":"component---src-templates-landing-page-js","36":"component---src-templates-mobile-application-js","37":"component---src-templates-network-penetration-testing-js","38":"component---src-templates-network-security-testing-js","39":"component---src-templates-network-vulnerability-scanning-js","40":"component---src-templates-ppc-main-lp-page-js","41":"component---src-templates-ppc-main-lp-thanks-page-js","42":"component---src-templates-resources-page-js","43":"component---src-templates-resources-post-js","44":"component---src-templates-resources-post-thanks-js","45":"component---src-templates-security-assessments-js","46":"component---src-templates-sitemap-js","47":"component---src-templates-ssdlc-development-phase-js","48":"component---src-templates-ssdlc-introduction-js","49":"component---src-templates-ssdlc-page-js","50":"component---src-templates-ssdlc-planning-design-phase-js","51":"component---src-templates-ssdlc-release-phase-js","52":"component---src-templates-ssdlc-requirements-phase-js","53":"component---src-templates-ssdlc-security-training-phase-js","54":"component---src-templates-ssdlc-verification-testing-phase-js","55":"component---src-templates-static-analysis-js","56":"component---src-templates-terms-and-conditions-for-giveaway-js","57":"component---src-templates-thanks-page-js","58":"component---src-templates-video-page-js","59":"component---src-templates-web-application-js","60":"component---src-templates-web-dynamic-penetration-testing-js","61":"component---src-templates-web-hybrid-analysis-js","62":"component---src-templates-web-static-analysis-js","63":"component---src-templates-why-security-testing-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"a22fa6d91b93a9d3ea9c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
